module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c3786aedc4f52d309d7d570dbaf0f6a5.png";